var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newNavigateActionHeader(data) {
    var instance = {
        __type: "NavigateActionHeader:#DecisionsFramework.ServiceLayer.Actions",
        Ni: null,
        PageParameters: null,
        Url: null,
        Id: null,
        Tp: null,
        Nm: null,
        Ca: null,
        SCa: null,
        Or: 0,
        Fv: null,
        CeFv: true,
        Tr: false,
        Pa: false,
        HT: null,
        NTNM: null,
        Flg: null
    };
    return __assign(__assign({}, instance), data);
}
export function isNavigateActionHeader(object) {
    return object.__type === "NavigateActionHeader:#DecisionsFramework.ServiceLayer.Actions";
}
